module.exports = __webpack_public_path__ + "static/dash-2-39673e4569d4770ea5817ef30783c8da.png";